import { getSubmittableFileDefinitions } from 'utils/dictionaryHelpers';
import AnalytesTable from './AnalytesTable';
import AnnotationsTable from './AnnotationsTable';
import CaseOverviewTable from './CaseOverviewTable';
import CasesTable from './CasesTable';
import DataValidationTable from './DataValidationTable';
import DynamicEntityTable from './DynamicEntityTable';
import NotSubmittableFileEntityTable from './NotSubmittableFileEntityTable';
import QCEntityTable from './QCEntityTable';
import QCErrorDetailSummaryTable from './QCErrorSummaryTable';
import QCErrorSeveritySummaryTable from './QCErrorSeveritySummaryTable';
import QCMetadataTable from './QCMetadataTable';
import SamplesTable from './SamplesTable';
import TransactionsTable from './TransactionsTable';

export {
  AnalytesTable,
  AnnotationsTable,
  CaseOverviewTable,
  CasesTable,
  DataValidationTable,
  SamplesTable,
  TransactionsTable,
  QCErrorDetailSummaryTable,
  QCErrorSeveritySummaryTable,
  QCMetadataTable,
};

export function TableRegistry(path, entity, defs) {
  if (path === 'qc') return QCEntityTable;

  const clinicalToTable = defs
    .filter(d => d.category === 'clinical')
    .reduce((acc, d) => ({ ...acc, [d.id]: NotSubmittableFileEntityTable }), {});

  const biospecimenToTable = defs
    .filter(d => d.category === 'biospecimen')
    .reduce((acc, d) => ({ ...acc, [d.id]: NotSubmittableFileEntityTable }), {});

  const submittableToTable = getSubmittableFileDefinitions({ defs })
    .reduce((acc, d) => ({ ...acc, [d.id]: DynamicEntityTable }), {});

  const entityToTable = {
    ...clinicalToTable,
    ...biospecimenToTable,
    ...submittableToTable,
    case: CasesTable,
    sample: SamplesTable,
    analyte: AnalytesTable,
    annotation: AnnotationsTable,
  };

  return entityToTable[entity] || DynamicEntityTable;
}
